import phone from 'phone';
import { adjustPhone } from '../adjustPhone';

export const isPhoneValid = (phoneValue) => {
  return phone(adjustPhone(phoneValue)).isValid;
};
